import { CreateSpeaker, Speaker } from '@/types/speakers.types';
import { Get, Post } from '../helpers';

export const FetchSpeakers = async (channel: number): Promise<Speaker[]> => {
  return Get({
    path: `/v3/admin/events/speakers/${channel}`,
  });
};

export const InsertSpeaker = async (
  baseLanguage: string,
  languages: string[],
  speaker: CreateSpeaker
): Promise<Speaker> => {
  return Post({
    path: '/v3/admin/events/speakers',
    body: {
      baseLanguage: baseLanguage,
      languages: languages,
      speaker: speaker,
    },
  });
};
